/**
 * Form Configuration
 * 
 * Email form handler endpoint configuration
 * 
 * For local development with Node.js server:
 *   NODE_FORM_URL: 'http://localhost:3001/api/contact'
 * 
 * For production:
 *   NODE_FORM_URL: 'https://your-domain.com/api/contact'
 * 
 * reCAPTCHA Configuration:
 *   Get your keys from: https://www.google.com/recaptcha/admin
 *   RECAPTCHA_SITE_KEY: Your reCAPTCHA v3 Site Key (public, safe to expose)
 *   Add to .env file: VITE_RECAPTCHA_SITE_KEY=your_site_key_here
 */

export const FORM_CONFIG = {
  // Node.js Form Handler Endpoint
  NODE_FORM_URL: import.meta.env.VITE_API_URL || 'https://setupccm.com/api/contact' , // ⬅️ UPDATE THIS FOR PRODUCTION!
  
  // reCAPTCHA v3 Site Key (public key - safe to expose in frontend)
  // Get your keys from: https://www.google.com/recaptcha/admin
  // Add to your .env file: VITE_RECAPTCHA_SITE_KEY=your_site_key_here
  RECAPTCHA_SITE_KEY: import.meta.env.VITE_RECAPTCHA_SITE_KEY || '',
};

